<template>
  <div class="tradique-layout">
    <div class="d-flex w-100 h-100">
      <div class="form-container">
        <slot />
      </div>
      <div class="promotion-container">
        <img :src="tradiqueBanner.banner" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    tradiqueBanner,
  }),
};
</script>

<style lang="scss">
.tradique-layout {
  direction: ltr;
  height: 100vh;
  background-color: #fff;

  .promotion-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 100%;

    img {
      width: 400px;
      height: 400px;
      object-fit: contain;
    }

    @media (max-width: 992px) {
      display: none;
    }
  }

  .form-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 768px;

    @media (max-width: 992px) {
      min-width: 720px;
    }

    @media (max-width: 992px) {
      width: 100%;
      min-width: unset;
    }
  }
}
</style>
